/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronUpRight = createReactComponent("chevron-up-right", "IconChevronUpRight", [
  ["path", { d: "M8 8h8v8", key: "svg-0" }]
]);

export { IconChevronUpRight as default };
//# sourceMappingURL=IconChevronUpRight.js.map
